import { Box, styled } from "@mui/material";

export const StyledHome = styled(Box)(({ theme }) => ({
  position: "relative",
  ".header": {
    background: theme.color.main,
    height: "30rem",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "20rem",
    h1: {
      color: theme.color.background,
    },
    ".imageWrapper": {
      right: "10rem",
      top: "10%",
      height: "80%",
      img: {
        width: "100%",
        height: "100%",
      },
    },
    ".icon": {
      display: "none",
      color: theme.color.contrastColor,
    },
  },
  ".newest": {
    padding: "5rem",
    h2: {
      fontFamily: "'Avant que...', sans-serif",
      fontSize: "3rem",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },
    ".artWrapper": {
      display: "flex",
      gap: "2rem",
      padding: "2rem",
      width: "fit-content",
      margin: "auto",
      border: `3px solid ${theme.color.main}`,
    },
  },
  [`@media screen and (max-width: ${theme.breakpoints.values.tablet}px)`]: {
    ".header": {
      paddingBlock: "5rem",
      gap: "3rem",
      height: "70vh",
      flexDirection: "column",
      ".imageWrapper": {
        right: "0",
        top: "0",
        height: "20rem",
      },
      ".icon": {
        display: "block",
      },
    },
    ".newest": {
      paddingBlock: "2rem",
      paddingInline: "0",
      h2: {
        textAlign: "center",
      },
      ".artWrapper": {
        justifyContent: "center",
        flexWrap: "wrap",
        gap: "2rem",
        padding: "1rem",
        boxSizing: "border-box",
        width: "90%",
        margin:"none",
      },
    },
  },
}));
